export default {"src":"/org/_next/static/media/ticket.4be0832c.svg","height":10,"width":14,"blurWidth":0,"blurHeight":0};